module.exports = __webpack_public_path__ + "static/media/teton_mountain.cd2e43b2.jpeg";